import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private loggingOut = false;

  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !this.loggingOut) {
          this.loggingOut = true;
          const authService = this.injector.get(AuthenticationService);
          try {
            authService.logout();
          } catch {
            this.loggingOut = false;
            // Ignore logout failures so the original 401 error continues to propagate.
          }
        }
        return throwError(error);
      })
    );
  }
}
